import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getCurrentUser } from 'src/api/auth';
import SplashScreen from 'src/components/SplashScreen';
import { setUserData } from 'src/store/account/actions';
import { getUser, isValidToken, setUser } from 'src/utils/auth';

const Auth: FC = ({ children }) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const initAuth = async () => {
      if (isValidToken()) {
        try {
          const user = await getCurrentUser();
          setUser(user);
          await dispatch(setUserData(user));
        } catch {
          await dispatch(setUserData(JSON.parse(getUser()!)));
        }
      }

      setLoading(false);
    };

    initAuth();
  }, [dispatch]);

  if (isLoading) {
    return <SplashScreen />;
  }

  return <>{children}</>;
};

export default Auth;
